export default "__VITE_ASSET__d24499ed__"